import axios from '../../../axiosConfig';

export const getAdminConsultants = async () => {
  const response = await axios.get('/admin/consultants');
  return response?.data?.consultants || response?.data || [];
};

export const getAdminConsultant = async (id) => {
  const response = await axios.get(`/admin/consultants/${id}`);
  return response?.data?.consultant || response?.data || null;
};

export const createAdminConsultant = async (payload) => {
  const response = await axios.post('/admin/consultants', payload);
  return response?.data;
};

export const assignAdminConsultantOwner = async (id, payload) => {
  const response = await axios.post(`/admin/consultants/${id}/owners`, payload);
  return response?.data;
};

export const swapAdminConsultantOwner = async (id, payload) => {
  const response = await axios.post(`/admin/consultants/${id}/swap_owner`, payload);
  return response?.data;
};
